import { COLLECTION_DYNAMIC_CONTENT_TYPES } from "./blocks";

export const CALENDAR_PERIODS = {
  ANY_DATE: "any_date",
  TODAY: "today",
  THIS_WEEK: "this_week",
  THIS_MONTH: "this_month",
};

export const CALENDAR_VIEWS = {
  DAY: "day",
  WEEK: "week",
};

export const DYNAMIC_TIMEZONE_OPTIONS = {
  APP: "app",
  USER: "user",
};

export const canFilterCalendar = (contentType: string) =>
  !contentType || contentType === COLLECTION_DYNAMIC_CONTENT_TYPES.ANY;

export const BADGE_TAGS = {
  COMPLETED: `<div class="material-icons-round v-icon badge-status --completed">done</div>`,
  MISSED: `<div class="material-icons-round v-icon badge-status --missed">close</div>`,
  HAS_CONTENT: `<div class="v-icon badge-status --has-content" />`,
} as const;
